module.exports = __webpack_public_path__ + "static/media/2020.12.12收看《初心 使命》专题片.dfb329d0.jpg";